export const phoneCodePattern = '$1';
export const phoneNumberBeforeDashPattern = '($1) $2';
export const fullPhoneNumberPattern = '($1) $2-$3';
